import { HighlightsTextItem } from '@cmg/design-system';
import { useIntl } from '@cmg/i18n';

import { SecurityType } from '../../../../../graphql';
import { securityTypeOfferingHeaderLabels } from './SizeInSharesTitleItem.model';

type SizeInSharesTitleItemProps = {
  securityType: SecurityType;
  sizeInShares?: number | null;
};

export default function SizeInSharesTitleItem({
  securityType,
  sizeInShares,
}: Readonly<SizeInSharesTitleItemProps>) {
  const intl = useIntl();

  return (
    <HighlightsTextItem
      name="SIZE"
      text={
        sizeInShares
          ? `${intl.formatNumber(sizeInShares, { format: 'integer' })} ${
              securityTypeOfferingHeaderLabels[securityType]
            }`
          : '-'
      }
    />
  );
}
